export interface CompanyBrand {
  companyName: string;
  logoDataUrl: string | null;
  primaryColor: string;
  accentColor: string;
  successColor: string | null;
  warningColor: string | null;
  errorColor: string | null;
  fontFamily: string;
  // item 77 — company slogan/tagline; shown in the UI + on all PDFs
  slogan: string | null;
  onboardingCompleted: boolean;
}

// must stay in sync with CompanyBrandSettings.AllowedFonts on the backend
// item 852 — Albert Sans + Barlow (the RNWY kit) added for the Proposal Portal brand
export const ALLOWED_FONTS = ['Roboto', 'Montserrat', 'Raleway', 'Lato', 'Inter', 'Albert Sans', 'Barlow'];

// Basix brand kit defaults (brand/tokens.json) — what the backend returns when unset
export const DEFAULT_BRAND: CompanyBrand = {
  companyName: '',
  logoDataUrl: null,
  primaryColor: '#002d45',
  accentColor: '#59d140',
  successColor: null,
  warningColor: null,
  errorColor: null,
  fontFamily: 'Roboto',
  slogan: null,
  onboardingCompleted: true,
};
